import styled from 'styled-components';
import { Switch } from 'antd';

import React from 'react';

const ToggleSwitch = styled(Switch)`
  margin-right: 15px;
  border-radius: 100px !important;
`;

const ReviewAnswerFieldSwitchType = ({ isSelected, label }) => {
  return (
    <React.Fragment>
      <ToggleSwitch disabled={true} checked={isSelected} />
      <span> {label} </span>
    </React.Fragment>
  );
};

export default ReviewAnswerFieldSwitchType;
